/**
 * This is a wrapper component for different Layouts.
 * Topbar should be added to this wrapper.
 */
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import css from './LayoutWrapperTopbar.module.css';

const LayoutWrapperTopbar = props => {
  const { className, rootClassName, children } = props;
  const classes = clsx(rootClassName || css.root, className);

  return <div className={classes}>{children}</div>;
};

LayoutWrapperTopbar.defaultProps = {
  className: null,
  rootClassName: null,
};

const { node, string } = PropTypes;

LayoutWrapperTopbar.propTypes = {
  children: node.isRequired,
  className: string,
  rootClassName: string,
};

export default LayoutWrapperTopbar;
